import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import List from "@material-ui/core/List";

import SettingsSection from "./settings-section";
import SettingsOption from "./settings-option";
import SettingsOptionSwitch from "./settings-option-switch";
import SettingsOptionLanguageSelect from "./settings-option-language-select";
import {getTranslation} from "../../helpers/get-translation";


const styles = theme => ({
	root: {

	},
	settingsList: {
		padding: 0,
	},
});

function SettingsScreen(props) {
	const { classes,
		getSocial,
		getOther,
		getAccount,
		settings,
		soundOnClick,
		vibrateOnClick,
		isDeviceAndroid,
		addLoadingScreen,
		removeLoadingScreen } = props;
	const soundStateText = settings.isSound ? getTranslation("settings_sound_on") : getTranslation("settings_sound_off");
	const vibrationStateText = settings.isVibrate ? getTranslation("settings_vibration_on") : getTranslation("settings_vibration_off");

	return (
		<div className={classes.root}>
			<List className={classes.settingsList} component="ul">
				<SettingsSection name={getTranslation("settings_header_your_account")}>
					{getAccount()
						.map(objectProps => {
							return <SettingsOption key={`option-${objectProps.name}`} {...objectProps} />
						})}
				</SettingsSection>
				<SettingsSection name={getTranslation("settings_header_social")}>
					{getSocial()
						.map(objectProps => (
							<SettingsOption key={`option-${objectProps.name}`} {...objectProps} />
						))}
				</SettingsSection>
				<SettingsSection name={getTranslation("settings_header_media")}>
					<SettingsOptionSwitch
						name={`${soundStateText}`}
						img={getTranslation("image_settings_sound")}
						state={settings.isSound}
						onClick={soundOnClick}
					/>
					{isDeviceAndroid &&
						<SettingsOptionSwitch
							name={`${vibrationStateText}`}
							img={getTranslation("image_settings_sound")}
							state={settings.isVibrate}
							onClick={vibrateOnClick}
						/>
					}
					<SettingsOptionLanguageSelect
						state={settings.isSound}
						onClick={soundOnClick}
						addLoadingScreen={addLoadingScreen}
						removeLoadingScreen={removeLoadingScreen}
						isLast={true}
					/>
				</SettingsSection>
				<SettingsSection name={getTranslation("settings_header_other")}>
					{getOther()
						.map(objectProps => {
							return <SettingsOption key={`option-${objectProps.name}`} {...objectProps} />
						})}
				</SettingsSection>
			</List>
		</div>
	);
}

SettingsScreen.propTypes = {
	isDeviceAndroid: PropTypes.bool.isRequired,
	classes: PropTypes.shape({}).isRequired,
	settings: PropTypes.object.isRequired,
	getSocial: PropTypes.func.isRequired,
	getOther: PropTypes.func.isRequired,
	getAccount: PropTypes.func.isRequired,
	soundOnClick: PropTypes.func.isRequired,
	vibrateOnClick: PropTypes.func.isRequired,
	addLoadingScreen: PropTypes.func.isRequired,
	removeLoadingScreen: PropTypes.func.isRequired,
	push: PropTypes.func.isRequired,
};

export default withStyles(styles)(SettingsScreen);
